import Color from 'color';
import type { ProjectConferenceTagWithMetadata } from '@trinity/chat/api/interfaces/projects';

export type TagItem = ProjectConferenceTagWithMetadata & {
  children: ProjectConferenceTagWithMetadata[];
};

export type TagStateValue = {
  tags: TagItem[];
};

export declare namespace TagActions {
  type Initialize = {
    type: 'initialize';
    state: TagStateValue;
  };

  type AddTag = {
    type: 'add-tag';
    tag: ProjectConferenceTagWithMetadata;
  };

  type RemoveTag = {
    type: 'remove-tag';
    projectTagId: number;
  };

  type ReplaceState = {
    type: 'replace-state';
    state: TagStateValue;
  };

  type UpdateOrdinals = {
    type: 'update-ordinals';
    ordinals: Record<number, number>;
  };

  type UpdateTag = {
    type: 'update-tag';
    projectTagId: number;
    partialTag: Partial<Omit<ProjectConferenceTagWithMetadata, 'ordinal' | 'base' | 'id'>>;
    baseTag: Partial<Omit<ProjectConferenceTagWithMetadata['base'], 'id'>>;
  };

  type AllActions = AddTag | Initialize | RemoveTag | ReplaceState | UpdateOrdinals | UpdateTag;
}

export type ProjectTagsActions = TagActions.AllActions;

export namespace Tags {
  export const baseColors = [
    {
      highlight: '#CCECF9',
      menu: '#B4DFF1',
      hover: '#9CD3EA',
    },
    {
      highlight: '#DCDCF8',
      menu: '#C8C9F4',
      hover: '#ABACEB',
    },
    {
      highlight: '#F7C0CD',
      menu: '#EEAABA',
      hover: '#EF819C',
    },
    {
      highlight: '#E4F1CF',
      menu: '#D6E8B8',
      hover: '#C1DD93',
    },
    {
      highlight: '#C6F5F5',
      menu: '#AEF3F3',
      hover: '#8DECEC',
    },
    {
      highlight: '#F7DAD4',
      menu: '#EFB5AA',
      hover: '#E7917F',
    },
  ];

  export const LIGHTEN_FACTOR = .07;
  const lightenedColors = baseColors.map(c => ({
    highlight: new Color(c.highlight).lighten(LIGHTEN_FACTOR).hex(),
    menu: new Color(c.menu).lighten(LIGHTEN_FACTOR).hex(),
    hover: new Color(c.hover).lighten(LIGHTEN_FACTOR).hex(),
  }));

  const darkenedColors = baseColors.map(c => ({
    highlight: new Color(c.highlight).darken(LIGHTEN_FACTOR).hex(),
    menu: new Color(c.menu).darken(LIGHTEN_FACTOR).hex(),
    hover: new Color(c.hover).darken(LIGHTEN_FACTOR).hex(),
  }));

  export const tagColors = lightenedColors.concat(baseColors).concat(darkenedColors);

  export const defaultColor = tagColors[0].menu;

  export const PopperZIndex = 8;
}